import React from 'react';
import PropTypes from 'prop-types';
import Button from "antd/lib/button";

const ShowCodeButton = props => {
  return (
    <Button
      size="small"
      onClick={props.showCodeChange}
      style={{
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      {props.showCode ? "Show explanation" : "Show code"}
    </Button>
  );
};

ShowCodeButton.propTypes = {
  showCode: PropTypes.bool,
  showCodeChange: PropTypes.func
};

export default ShowCodeButton;


// WEBPACK FOOTER //
// ./src/steps/ShowCodeButton.js